export const gradetable = [
    {

        id: "G180482",
        grade: "O",
        percentage: "90% - 100%",
        gradePoints: "10",
        status: "Active",
        key:1
    },
    {

        id: "G180481",
        grade: "A+",
        percentage: "80% - 90%",
        gradePoints: "8",
        status: "Active",
        key:2
    },
    {

        id: "G180480",
        grade: "A",
        percentage: "70% - 80%",
        gradePoints: "6",
        status: "Active",
        key:3
    },
    {

        id: "G180479",
        grade: "B+",
        percentage: "60% - 70%",
        gradePoints: "4",
        status: "Active",
        key:4
    },
    {

        id: "G180478",
        grade: "B",
        percentage: "50% - 60%",
        gradePoints: "3",
        status: "Active",
        key:5
    },
    {

        id: "G180477",
        grade: "C+",
        percentage: "40% - 50%",
        gradePoints: "2",
        status: "Active",
        key:6
    },
    {

        id: "G180476",
        grade: "C",
        percentage: "35% - 40%",
        gradePoints: "1",
        status: "Active",
        key:7
    },
    {

        id: "G180475",
        grade: "F",
        percentage: "Below 35%",
        gradePoints: "0",
        status: "Active",
        key:8
    }
]
